import clsx from 'clsx';
import React from 'react';

import ArticleDetails from '../ArticleDetails';
import Header from '../Header';
import { PICTURE_CAPTION_CLASSES } from '../PictureCaption';
import { ThemeViewsProps } from '../interfaces';
import Content from './Content';

const Graphic = ({
  article: {
    addendum,
    advertisement,
    authors,
    commentsCount,
    commenters,
    featuredGraphic,
    freeBlurb,
    fullText,
    highlight,
    id,
    pickups,
    publishedAt,
    scriptList,
    subTitle,
    takeaway,
    title,
  },
  canShareArticle,
  canViewFullArticle,
  canViewComments,
  clipperProps,
  endOfArticleDeepResearchPrompts,
  env,
  isSEOBotAndArticleIsNotFree,
  midArticleUnitType,
  mostPopularArticles,
  newsletterId,
  relatedArticles,
  relatedEvent,
  suggestedAiPrompts,
}: ThemeViewsProps) => {
  return (
    <div className="px-16 sm:px-28">
      <div className="relative m-auto max-w-container-lg">
        <div className="mb-24 flex flex-col items-center justify-between sm:mb-48 lg:mb-72">
          <div className="z-10 w-full flex-1">
            <Header highlight={highlight} title={title} subTitle={subTitle} />
          </div>
        </div>
        <div
          className={clsx('relative m-auto lg:max-w-[1060px] xl:max-w-container-lg', {
            'mb-80 sm:mb-112': !!midArticleUnitType && canViewFullArticle,
          })}
        >
          <div className="flex flex-col-reverse md:flex-row md:gap-72 xl:gap-112">
            <div className="flex-1">
              <div className="mb-40 sm:mb-48 md:mb-64">
                <ArticleDetails
                  authors={authors}
                  commentsCount={commentsCount}
                  commenters={commenters}
                  publishedAt={publishedAt}
                  canShareArticle={canShareArticle}
                  articleId={id}
                />
              </div>
            </div>
            <div
              className={clsx(
                PICTURE_CAPTION_CLASSES,
                'hidden lg:block lg:w-[260px] lg:flex-shrink-0'
              )}
            />
          </div>
          <Content
            addendum={addendum}
            advertisement={advertisement}
            authors={authors}
            canViewFullArticle={canViewFullArticle}
            canViewComments={canViewComments}
            clipperProps={clipperProps}
            commentsCount={commentsCount}
            endOfArticleDeepResearchPrompts={endOfArticleDeepResearchPrompts}
            env={env}
            featuredGraphic={featuredGraphic}
            freeBlurb={freeBlurb}
            fullText={fullText}
            highlight={highlight}
            id={id}
            isSEOBotAndArticleIsNotFree={isSEOBotAndArticleIsNotFree}
            midArticleUnitType={midArticleUnitType}
            mostPopularArticles={mostPopularArticles}
            newsletterId={newsletterId}
            pickups={pickups}
            relatedArticles={relatedArticles}
            relatedEvent={relatedEvent}
            scriptList={scriptList}
            suggestedAiPrompts={suggestedAiPrompts}
            takeaway={takeaway}
          />
        </div>
      </div>
    </div>
  );
};

export default Graphic;
